import { donationFormatter } from "@/lib/utils";
import { SessionDocument } from "@ailenax-overlay/shared";
import { FC, useMemo } from "react";

interface SessionCardProps {
    session: SessionDocument | null;
    currentSubs: number;
    reset: () => void;
}

export const SessionCard: FC<SessionCardProps> = ({ session, currentSubs, reset }) => {
    const bits = useMemo(() => {
        if (!session) {
            return 0;
        }

        return Object.values(session.bits).reduce((prev, cur) => prev + cur, 0);
    }, [session]);

    const donos = useMemo(() => {
        if (!session) {
            return 0;
        }

        return Object.values(session.donations).reduce((prev, cur) => prev + cur, 0);
    }, [session]);

    const subs = useMemo(() => {
        if (!session) {
            return 0;
        }

        return Object.values(session.subs).reduce((prev, cur) => prev + cur, 0);
    }, [session]);

    return (
        <div className="col-span-12 grid gap-2">
            <form className="w-1/6 mx-auto flex flex-col flex-3/4 dark:bg-gray-800 p-5 rounded-3xl">
                <div className="relative z-0 flex-2/6 mb-2">
                    Subs: { subs.toLocaleString() }
                </div>
                <div className="relative z-0 flex-2/6 mb-2">
                    Bits: { bits.toLocaleString() }
                </div>
                <div className="relative z-0 flex-2/6 mb-2">
                    Donations: { donationFormatter.format(donos) }
                </div>
                <button type="button" className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800" onClick={() => reset()}>Reset</button>
            </form>
            <form className="w-1/6 mx-auto flex flex-col dark:bg-gray-800 p-5 justify-center rounded-3xl">
                Total Subs: { currentSubs.toLocaleString() }
            </form>
        </div>
    )
}